/**
 * Disable $button
 * @param  {jQuery} $button - Button to be disabled
 */
function disableButton($button) {
  $button.prop('disabled', true);
}

/**
 * Disable $button for 100ms
 * @param  {jQuery} $button - Button to be disabled temporarily
 */
function disableButtonTemporarily($button) {
  // disable the form submit button to avoid double requests
  disableButton($button);

  // re-enable submit after 100ms
  setTimeout(() => {
    enableButton($button);
  }, 100);
}

/**
 * Enable $button
 * @param  {jQuery} $button - Button to be enabled
 */
function enableButton($button) {
  $button.prop('disabled', false);
}

/** Get the form data in an Object with keys & values
 * @param  {HTMLElement} form - Form element to get formData from
 * @returns {Object} Object with keys being the form field names & value its values
 */
function getFormData(form) {
  const formDataEntries = new FormData(form).entries();
  const formDataObject = {};

  let iterator = formDataEntries.next();
  while (!iterator.done) {
    if (iterator.value) {
      const [key, value] = iterator.value;
      formDataObject[key] = value;
    }
    iterator = formDataEntries.next();
  }

  return formDataObject;
}

/**
 * Triggers change container selects
 * @param  {jQuery} container - form container
 */
function initSelectInputs(container) {
  const selectInputs = $('select', container);
  $.each(selectInputs, (index, element) => {
    if (element.selectedIndex > 0) {
      $(element).trigger('change');
    }
  });
}

/**
 * True if button is disabled
 * @param  {jQuery} $button - Button to check if disabled
 * @returns {boolean} true if $button is disabled, false if not
 */
function isButtonDisabled($button) {
  // check if submit button is disabled
  return !!$button.prop('disabled');
}

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 */
function loadFormErrors(parentSelector, fieldErrors, animate = true) {
  const forms = require('../../components/forms');

  // Display error messages and highlight form fields with errors.
  $.each(fieldErrors, (attr) => {
    const $field = $(`*[name=${attr}]`, parentSelector);
    forms.addFieldError($field, fieldErrors[attr]);
  });
  // Animate to top of form that has errors
  if (animate) {
    const scrollAnimate = require('base/components/scrollAnimate');
    scrollAnimate($(parentSelector));
  }
}

module.exports = {
  disableButton,
  disableButtonTemporarily,
  enableButton,
  getFormData,
  initSelectInputs,
  isButtonDisabled,
  loadFormErrors,
};
